var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CookieControl',{staticClass:"consent-wrapper",attrs:{"locale":this.$i18n.locale}})}
var staticRenderFns = []

export { render, staticRenderFns }